import {TweenLite} from "gsap";

import {Vector3} from 'three'

export function moveObjectToXY(x, y, object3D,camera) {

    // Make the sphere follow the mouse
    var vector = new Vector3(
        (x / window.innerWidth) * 2 - 1,
        -(y / window.innerHeight) * 2 + 1,
        -1);

    vector.unproject(camera);
    var dir = vector.sub(camera.position).normalize();
    var distance = -camera.position.z / dir.z;
    var pos = camera.position.clone().add(dir.multiplyScalar(distance));

    const targetPosition = object3D.position.clone();
    targetPosition.copy(pos.sub(object3D.position));
    //TweenLite.to(object3D.position, 5, {x: targetPosition.x, y: targetPosition.y,z:targetPosition.z})
}

export function createVectorFromScreenCoord(x,y,camera) {
    var vec = new Vector3(); // create once and reuse
    var pos = new Vector3(); // create once and reuse

    vec.set(
        ( x / window.innerWidth ) * 2 - 1,
        - ( y / window.innerHeight ) * 2 + 1,
        0 );

    vec.unproject( camera );

    vec.sub( camera.position ).normalize();

    var distance = - camera.position.z / vec.z;

    pos.copy( camera.position ).add( vec.multiplyScalar( distance ) );
    return pos;

}

/**
 * Convert vertical field of view to horizontal field of view, given an aspect
 * ratio. See https://arstechnica.com/civis/viewtopic.php?f=6&t=37447
 *
 * @param vfov - The vertical field of view.
 * @param aspect - The aspect ratio, which is generally width/height of the viewport.
 * @returns - The horizontal field of view.
 */
function vfovToHfov(vfov, aspect) {
    const {tan, atan} = Math
    return atan(aspect * tan(vfov / 2)) * 2
}

/**
 * Get the distance from the camera to fit an object in view by either its
 * horizontal or its vertical dimension.
 *
 * @param size - This should be the width or height of the object to fit.
 * @param fov - If `size` is the object's width, `fov` should be the horizontal
 * field of view of the view camera. If `size` is the object's height, then
 * `fov` should be the view camera's vertical field of view.
 * @returns - The distance from the camera so that the object will fit from
 * edge to edge of the viewport.
 */
function _distanceToFitObjectInView(size, fov) {
    const {tan} = Math
    return size / (2 * tan(fov / 2))
}

export function distanceToFitObjectToView(
    cameraAspect,
    cameraVFov,
    objWidth,
    objHeight
) {
    const objAspect = objWidth / objHeight
    const cameraHFov = vfovToHfov(cameraVFov, cameraAspect)

    let distance = 0

    if (objAspect > cameraAspect) {
        distance = _distanceToFitObjectInView(objHeight, cameraVFov)
    } else if (objAspect <= cameraAspect) {
        distance = _distanceToFitObjectInView(objWidth, cameraHFov)
    }

    return distance
}

export function  visibleHeightAtZDepth  ( depth, camera )  {
    // compensate for cameras not positioned at z=0
    const cameraOffset = camera.position.z;
    if ( depth < cameraOffset ) depth -= cameraOffset;
    else depth += cameraOffset;

    // vertical fov in radians
    const vFOV = camera.fov * Math.PI / 180;

    // Math.abs to ensure the result is always positive
    return 2 * Math.tan( vFOV / 2 ) * Math.abs( depth );
};

export function visibleWidthAtZDepth ( depth, camera )  {
    const height = visibleHeightAtZDepth( depth, camera );
    return height * camera.aspect;
};

export function getDistance(vector1, vector2) {
    const dx = vector1.x - vector2.x;
    const dy = vector1.y - vector2.y;
    const dz = vector1.z - vector2.z;
    return Math.sqrt(dx*dx+dy*dy+dz*dz);
}
